import { useCallback, useState } from 'react';
import { TableHeaderActionType } from '../types';

export const useThModalHandler = () => {
	const [isOpen, setIsOpen] = useState(false);
	const [action, setAction] = useState<TableHeaderActionType | null>(null);

	const openThModal = useCallback((action: TableHeaderActionType) => {
		setAction(action);
		setIsOpen(true);
	}, []);

	const closeThModal = useCallback(() => {
		setIsOpen(false);
		setAction(null);
	}, []);

	return {
		isOpen,
		action,
		openThModal,
		closeThModal,
	};
};
